var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24 12.2999H8.76V7.73989H7.24V12.2999ZM8 0.899902C3.80519 0.899902 0.400391 4.3047 0.400391 8.49989C0.400391 12.6951 3.80519 16.0999 8 16.0999C12.1952 16.0999 15.6 12.6951 15.6 8.49989C15.6 4.3047 12.1952 0.899902 8 0.899902ZM8 14.5799C4.64841 14.5799 1.92039 11.8515 1.92039 8.49989C1.92039 5.1483 4.64841 2.4199 8 2.4199C11.3516 2.4199 14.08 5.1483 14.08 8.49989C14.08 11.8515 11.3516 14.5799 8 14.5799ZM7.24 6.2199H8.76V4.6999H7.24V6.2199Z",
    fill: "#0288d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.042ab36eb8e6cfcebb905c7c8d560492.svg";
export { ForwardRef as ReactComponent };